import config from 'config.json';

BasicFactory.$inject = ['$resource'];

export default function BasicFactory($resource) {

  return {
    /**
     * Metodo que se encarga de predefinir el endpoint que se va a usar para las llamadas.
     * @param {string} endpoint.
     */
    setup(endpoint) {
      this.endpoint = endpoint;
    },

    /**
     * Metodo que se corresponde con un GET /endpoint.
     * 
     * @param {Object} filter - Filtros a enviar al backend.
     */
    all(filter) {
      const rsp = $resource(config.serverURL + `/${this.endpoint}/:id`, { id: '@id' }, {
        query: {
          method: 'GET',
          data: {},
          isArray: false
        }
      });
      return filter ? rsp.query(filter).$promise : rsp.query().$promise;
    }
  };
}


// WEBPACK FOOTER //
// ./src/core/services/basicfactory.js